var Codec = require('io/codec');

var serialiser = {
    read : function(input, Enum) {
        var i = Codec.readByte(input);
        
        for (var k in Enum) {
            if (Enum[k] === i || Enum[k].id !== undefined && Enum[k].id === i) {
                return k;
            }
        }

        throw new Error('Unknown id (' + i + ') for enum');           
    },
    write : function(output, id) {
        Codec.writeByte(output, id);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/serialisers/enum-converter.js
// module id = 296
// module chunks = 1